import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CaretDown } from "@phosphor-icons/react";
import { Reveal, Overline } from "./Reveal";
import { FAQS } from "../../data/site";

export const FAQ = () => {
    const [active, setActive] = useState(0);
    return (
        <section
            id="faq"
            data-testid="faq"
            className="mx-auto max-w-[1400px] px-6 md:px-10 py-24 md:py-36"
        >
            <div className="grid lg:grid-cols-12 gap-12">
                <div className="lg:col-span-4">
                    <Reveal>
                        <Overline>Soalan Lazim</Overline>
                    </Reveal>
                    <Reveal delay={0.08}>
                        <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink leading-[1.02]">
                            Ada soalan? Kami jawab.
                        </h2>
                    </Reveal>
                </div>

                <div className="lg:col-span-8 border-t border-border">
                    {FAQS.map((f, i) => {
                        const open = active === i;
                        return (
                            <div key={f.q} className="border-b border-border">
                                <button
                                    data-testid={`faq-toggle-${i}`}
                                    onClick={() => setActive(open ? -1 : i)}
                                    className="w-full flex items-center justify-between gap-6 py-7 text-left group"
                                >
                                    <span className="font-display text-xl md:text-2xl text-ink tracking-tight group-hover:text-accent transition-colors duration-300">
                                        {f.q}
                                    </span>
                                    <CaretDown
                                        size={22}
                                        className={`shrink-0 text-accent transition-transform duration-400 ${
                                            open ? "rotate-180" : ""
                                        }`}
                                    />
                                </button>
                                <AnimatePresence initial={false}>
                                    {open && (
                                        <motion.div
                                            initial={{ height: 0, opacity: 0 }}
                                            animate={{ height: "auto", opacity: 1 }}
                                            exit={{ height: 0, opacity: 0 }}
                                            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                                            className="overflow-hidden"
                                        >
                                            <p className="pb-7 max-w-2xl text-ink-soft leading-relaxed">
                                                {f.a}
                                            </p>
                                        </motion.div>
                                    )}
                                </AnimatePresence>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
